import Button from 'components/Button';
import GenericModal from 'components/Modal/GenericModal';
import React from 'react';
import { ParagraphSmallRegular } from 'styles/elements/typography';

interface RecordingTimeWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  continueDisabled?: boolean;
}

const RecordingTimeWarningModal: React.FC<RecordingTimeWarningModalProps> = ({
  isOpen,
  onClose,
  onContinue,
  continueDisabled = false,
}) => (
  <GenericModal isOpen={isOpen} onClose={onClose} title="Recording will end soon">
    <div>
      <ParagraphSmallRegular>
        Your recording has reached 50 minutes. It will automatically stop at 60 minutes.
      </ParagraphSmallRegular>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '24px' }}>
        <Button
          id="recording-time-warning-continue-button"
          state="primary"
          buttonText="Resume"
          onClick={() => {
            onClose();
            onContinue();
          }}
          disabled={continueDisabled}
          data-automation="recording-time-warning-continue-button"
        />
      </div>
    </div>
  </GenericModal>
);

export default RecordingTimeWarningModal;
